import { STEP_PATHS, LOCAL_STORE_ITEMS } from 'constants/bulk-import';

export const getStepPath = (step?: string | number) => {
  const savedStep = localStorage.getItem(LOCAL_STORE_ITEMS.STEP) || '1';
  return STEP_PATHS[String(step)] || STEP_PATHS[savedStep];
};

export const getStepNumber = (stepPath?: string): number | null => {
  let result: number | null = null;
  Object.entries(STEP_PATHS).forEach(([step, path]) => {
    if (path === stepPath) result = Number(step);
  });
  return result;
};
